"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnectors = exports.OfflineConnectors = exports.EthChainIds = exports.Blockchains = void 0;
var utils_1 = require("@unifiprotocol/utils");
Object.defineProperty(exports, "Blockchains", { enumerable: true, get: function () { return utils_1.Blockchains; } });
var EthChainIds;
(function (EthChainIds) {
    EthChainIds[EthChainIds["Eth"] = 1] = "Eth";
    EthChainIds[EthChainIds["EthRinkeby"] = 4] = "EthRinkeby";
    EthChainIds[EthChainIds["EthGoerli"] = 5] = "EthGoerli";
    EthChainIds[EthChainIds["Bsc"] = 56] = "Bsc";
    EthChainIds[EthChainIds["BscTestnet"] = 97] = "BscTestnet";
    EthChainIds[EthChainIds["Iotex"] = 4689] = "Iotex";
    EthChainIds[EthChainIds["Harmony"] = 1666600000] = "Harmony";
    EthChainIds[EthChainIds["Polygon"] = 137] = "Polygon";
    EthChainIds[EthChainIds["Avalanche"] = 43114] = "Avalanche";
    EthChainIds[EthChainIds["BTTC"] = 199] = "BTTC";
    EthChainIds[EthChainIds["FTM"] = 250] = "FTM";
    EthChainIds[EthChainIds["OntologyTestnet"] = 5851] = "OntologyTestnet";
    EthChainIds[EthChainIds["Ontology"] = 58] = "Ontology";
    /**
     * Non real chain ids
     * Format: 1337XXXX where XXXX is an autoincrement
     * We need this for the nature of the bridge, using chainid as configuration
     * Check existing ones here: https://chainlist.org/
     */
    EthChainIds[EthChainIds["Tron"] = 13370001] = "Tron";
})(EthChainIds = exports.EthChainIds || (exports.EthChainIds = {}));
var OfflineConnectors;
(function (OfflineConnectors) {
    OfflineConnectors["UnifiProxy"] = "unifiproxy";
    OfflineConnectors["Cloudflare"] = "cloudflare";
    OfflineConnectors["EtherScan"] = "etherscan";
    OfflineConnectors["BscDataseed"] = "bscdataseed";
    OfflineConnectors["TronGrid"] = "trongrid";
    OfflineConnectors["Alchemy"] = "alchemy";
    OfflineConnectors["Harmony"] = "harmony";
    OfflineConnectors["Polygon"] = "polygon";
    OfflineConnectors["Iotex"] = "iotex";
    OfflineConnectors["Avalanche"] = "avalanche";
    OfflineConnectors["BTTC"] = "bttc";
    OfflineConnectors["OntologyTestnet"] = "ontologytestnet";
    OfflineConnectors["FTM"] = "ftm";
})(OfflineConnectors = exports.OfflineConnectors || (exports.OfflineConnectors = {}));
var WalletConnectors;
(function (WalletConnectors) {
    WalletConnectors["HarmonyOneWallet"] = "HarmonyOneWallet";
    WalletConnectors["Binance"] = "binance";
    WalletConnectors["Metamask"] = "metamask";
    WalletConnectors["OntoWallet"] = "ontowallet";
    WalletConnectors["MathWallet"] = "mathwallet";
    WalletConnectors["TronLink"] = "tronlink";
    WalletConnectors["TrustWallet"] = "trustwallet";
    WalletConnectors["MetamaskCompatible"] = "metamaskCompatible";
    WalletConnectors["WalletConnect"] = "walletConnect";
})(WalletConnectors = exports.WalletConnectors || (exports.WalletConnectors = {}));
